// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {startCase} from 'lodash';

// Components
import Button from '../core/button';
import Form from '../core/form';
import Input from '../core/input';
import Select from '../core/select';
import SubmitButton from '../core/submit-button';
import Textarea from '../core/textarea';

// Styles
import './display-path-modifier-form.scss';

function DisplayPathModifierForm({formData, formName, onReset, setFieldValue}) {
    const getFieldProps = (fieldName, type) => ({
        className: type === 'select' ? 'display-path-modifier-form--select' : 'display-path-modifier-form--input',
        label: startCase(fieldName),
        name: fieldName,
        type,
    });

    const handleResetClick = (event) => {
        event && event.preventDefault && event.preventDefault();

        onReset(false);
    };

    const formProps = {
        className: 'display-path-modifier-form',
        fixedPositionedResponse: true,
        name: formName,
        resetOnSubmit: formName === 'createDisplayPathModifier',
        submitData: true,
    };

    const shouldShowTransformation = () => formData.values && formData.values.method !== 'REMOVE';

    return (
        <Form {...formProps}>
            <Input {...getFieldProps('match')} disableAutofill={true} validate={['required']} />
            <Select
                {...getFieldProps('method', 'select')}
                validate={['required']}
                onChange={(e) => { setFieldValue('status', e.target.value); }}
            >
                <option value="">Choose a Method</option>
                <option value="ADD">Add</option>
                <option value="REMOVE">Remove</option>
                <option value="REPLACE">Replace</option>
            </Select>
            {shouldShowTransformation() ? <Input {...getFieldProps('transformation')} disableAutofill={true} /> : null}
            <Textarea {...getFieldProps('description')} />
            <SubmitButton label="Save" />
            <Button
                {...{
                    onClick: handleResetClick,
                    className: 'display-path-modifier-form--reset',
                }}
            >
                Reset
            </Button>
        </Form>
    );
}

DisplayPathModifierForm.propTypes = {
    // editing: PropTypes.bool,
    formData: PropTypes.object,
    formName: PropTypes.string.isRequired,
    onReset: PropTypes.func,
    setFieldValue: PropTypes.func,
};

export default DisplayPathModifierForm;
